import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../../components/FinalMolGrid/libs/data/gridColumnType";

const initState = {
  statusName: '',
  isActive: '',
  isComplete: '',
  isDefault:''
}

export const projectStatusFormData = {
  name: " Project Status Form",
  initialState: initState,
  section: [
    {
      sectionId: "projectStatus",
      title: "Project Status",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-1",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "statusName",
          label: "Status Name",
          Field_Name: " status name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "statusName",
          fieldSetting: {
            placeholder: "Please Enter Status Name",
            allowSpace: true,
            isDisable: false,
            maxLength: 50,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
          },
        },
        {
          id: "isActive",
          label: "Is Active",
          Field_Name: "active",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          class: "justify-content-end",
          fieldSetting: {
            placeholder: "Active",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-2 col-md-2 mb-2 release-btn validation-left-0 checkbox-style mt-2",
          },
        },
        {
          id: "isComplete",
          label: "Is Complete",
          Field_Name: "complete",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isComplete",
          class: "justify-content-end",
          fieldSetting: {
            placeholder: "Complete",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-2 col-md-2 mb-2 release-btn validation-left-0 checkbox-style mt-2",
          },
        },
        {
          id: "isBacklog",
          label: "Is Backlog",
          Field_Name: "backlog",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isBacklog",
          class: "justify-content-end",
          fieldSetting: {
            placeholder: "backlog",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-2 col-md-2 mb-2 release-btn validation-left-0 checkbox-style mt-2",
          },
        },
        {
          id: "isDefault",
          label: "Is Default",
          Field_Name: "backlog",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isDefault",
          class: "justify-content-end",
          fieldSetting: {
            placeholder: "Default",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-2 col-md-2 mb-2 release-btn validation-left-0 checkbox-style mt-2",
          },
        },
      ]
    }
  ]
}


export const ProjectStatusGridConfig = {
  columns: [
    {
      name: "Project Status Name",
      fieldName: "statusName",
      allowShort: false,
    },
    {
      name: "Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
    },
    {
      name: "Complete",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isComplete",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
}
export default projectStatusFormData;